module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0627.31247a0e.jpg";